<template>
    <div class='jbDialog'>
        <div class="jbDialogIn animate__animated animate__fadeInDown animate__faster">
            <div class="tit">
                {{step==1?'交办通报':'选择单位'}}
                <i class="iconfont iconcha" @click="close"></i>
            </div>
            <div class="content">
                <el-form ref="form" :model="form" :rules="rules" :class="step==2?'hideForm':''" label-width="120">
                    <el-form-item prop="title" label="通报标题">
                        <el-input v-model="form.title" placeholder="请输入通报标题" maxlength="150"></el-input>
                    </el-form-item>
                    <el-form-item prop="yqUrl" label="舆情链接">
                        <el-input v-model="form.yqUrl" placeholder="请输入舆情链接" maxlength="300" disabled></el-input>
                    </el-form-item>
                    <el-form-item prop="yqContent" label="舆情摘要">
                        <el-input type="textarea" :rows="6" v-model="form.yqContent" placeholder="请输入舆情摘要"  maxlength="4000"></el-input>
                    </el-form-item>
                    <el-form-item prop="timeLimit" style="display:inline-block;width:48%" label="时限要求">
                        <el-select v-model="form.timeLimit" placeholder="请选择时限要求">
                            <el-option v-for="item in limitOptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="form.timeLimit" placeholder="请输入通报标题"></el-input> -->
                    </el-form-item>
                    <el-form-item prop="yqTag" style="display:inline-block;width:48%;margin-left:4%" label="舆情标签">
                        <el-select v-model="form.yqTag" placeholder="请选择舆情标签">
                            <el-option v-for="item in yqTagOptions" :key="item.value" :label="item.name" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="demand" label="建议要求">
                        <el-input type="textarea" :rows="6" v-model="form.demand" placeholder="请输入建议要求" maxlength="500"></el-input>
                    </el-form-item>
                </el-form>
                <add-feedback ref="addFeedback" class="addFeedback" :treeNode22="treeNode" @getFinalCheckNodes="getFinalCheckNodes" @allCheck="allCheck"></add-feedback>
            </div>
            <div class="foot">
                <div class="next" v-if="step==1" @click="next('form')">下一步</div>
                <div class="next2" v-if="step==2" @click="prev">上一步</div>
                <div class="next" v-if="step==2" @click="fabu">发布</div>
            </div>
        </div>
    </div>
</template>
<script>
// import yqDetailApi from '@/api/yqDetail.js'
import warningApi from '@/api/warning';
import addFeedback from '@/components/addFeedback/addFeedback';
export default{
    name:'jbDialog',
    components:{addFeedback},
    data(){
        return{
            id:'',
            form:{
                title:'',
                yqUrl:'',
                yqContent:'',
                timeLimit:'',
                yqTag:'',
                demand:'',
                yqTitle:''
            },

            rules:{
                title:[
                    {required:true,message:'请输入通报标题',trigger:['change','blur']},
                    {min:1,max:150,message:'长度在0到150个字符',trigger:['change','blur']}
                ],
                yqUrl:[
                    {required:true,message:'请输入舆情链接',trigger:['change','blur']},
                    {min:1,max:500,message:'长度在0到500个字符',trigger:['change','blur']}
                ],
                yqContent:[
                    {required:true,message:'请输入舆情摘要',trigger:['change','blur']},
                    {min:1,max:4000,message:'长度在0到4000个字符',trigger:['change','blur']}
                ],
                timeLimit:[
                    {required:true,message:'请选择时限要求',trigger:['change','blur']},
                ],
                yqTag:[
                    {required:true,message:'请选择舆情标签',trigger:['change','blur']},
                ],
                demand:[
                    {required:true,message:'请输入建议要求',trigger:['change','blur']},
                    {min:1,max:1000,message:'长度在0到1000个字符',trigger:['change','blur']}
                ],
            },
            limitOptions:[{
                value:1,label:'1小时'
            },{
                value:2,label:'3小时'
            },{
                value:3,label:'6小时'
            },{
                value:4,label:'1天'
            },{
                value:5,label:'2天'
            },{
                value:6,label:'3天'
            },{
                value:7,label:'4天'
            },{
                value:8,label:'5天'
            },{
                value:9,label:'6天'
            },{
                value:10,label:'7天'
            }],
            yqTagOptions:[],
            step:1,
            selectedNode: [],
			allCheckval: false,
			treeNode: [],
			ejNodes: [],
            selectedKeys: [],
        }
    },
    props:{
    },
    created(){
        this.getTag()
        this.getTree()
    },
    mounted(){

    },
    computed:{
    },
    methods:{
        close(){
            this.$emit('dialogClose')
        },
        _notice(message,type){
			this.$message({message,type});
		},
        getTag(){
            warningApi.getTag({key:'assign_tag'}).then(res=>{
                // console.log(res)
                this.yqTagOptions=res.returnData
            })
        },
        next(formName){
            this.$refs[formName].validate((valid) => {
                // console.log(valid)
                if (valid){
                    // console.log(`验证通过`)
                    // 当选中的节点 和  树的二级节点的数量相等时  全选设为 true
                    if (this.selectedNode.length == this.ejNodes.length) {
                        this.allCheckval = true;
                    }
                    this.$refs.addFeedback.show();
                    this.step=2
                }else{
                    this._notice('请填写完整信息','warning')
                }
            })
        },
        getFenzhong(val){
            switch (val) {
                case 1:
                    return 60
                    break;
                case 2:
                    return 3*60
                    break;
                case 3:
                    return 6*60
                    break;
                case 4:
                    return 24*60
                    break;
                case 5:
                    return 2*24*60
                    break;
                case 6:
                    return 3*24*60
                    break;
                case 7:
                    return 4*24*60
                    break;
                case 8:
                    return 5*24*60
                    break;
                case 9:
                    return 6*24*60
                    break;
                case 10:
                    return 7*24*60
                    break;
            }
        },
        prev(){
            this.step=1
        },
        fabu(){
            if(this.selectedKeys.length==0){
                return this._notice('请选择交办单位','warning')
            }
            let apiForm=this.form
            apiForm.timeLimit=this.getFenzhong(apiForm.timeLimit)
            apiForm.yqTitle=apiForm.title
            // console.log(apiForm)
            let query={
                ...apiForm,
                addCustIds:this.selectedKeys.toString()
            }
            warningApi.addJiaoban(query).then(res=>{
                // console.log(res)
                if(res.returnCode==100){
                    this._notice('交办通报成功','success')
                    this.$emit('dialogClose')
                }
            })
        },
        async getTree(){
            await warningApi.getTree({}).then(res => {
                // console.log(res.returnData)
                let tree=[]
                res.returnData.forEach(element => {
                    if(element.id==1){
                        let level1Obj={
                            id:element.id,
                            label:element.name,
                            children:[]
                        }
                        tree.push(level1Obj)
                    }
                });
                res.returnData.forEach(element => {
                    if(element.pid==1){
                        let level2Obj={
                            id:element.id,
                            label:element.name,
                            children:[]
                        }
                        tree[0].children.push(level2Obj)
                    }
                });
                tree[0].children.forEach(element => {
                    res.returnData.forEach(element2 => {
                        if(element.id==element2.pid){
                            element.children.push({
                                id:element2.id,
                                label:element2.name
                            })
                        }
                    });
                });
                // console.log(tree)
                this.treeNode=tree
			});
        },
        getFinalCheckNodes(val,allCheckval) {
			this.allCheckval = allCheckval;
			this.selectedNode = val;
			this.selectedKeys = [];
			this.selectedNode.forEach(element => {
				this.selectedKeys.push(element.id);
			});
        },
        allCheck(val) {
			// console.log(val);
			this.allCheckval = val;
        },
    },
    watch:{
    },
    filters:{
    }
}
</script>
<style scoped lang='stylus'>
@import './jiaobanDialog.styl';
</style>